var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-1"},_vm._l((_vm.selectComponents),function(cmp,index){return _c('b-col',{key:index,class:{
            'pr-md-0': index < _vm.selectComponents.length - 1
        },attrs:{"md":cmp[1]}},[_c(cmp[0],{tag:"component",attrs:{"clearable":_vm.isClearable(cmp[0], _vm.cmpArr),"storeKey":cmp[2]}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }